import { LANGUAGES, LANGUAGE_DE } from '@common/constants/languages';

export function getLocale(locale) {
  return LANGUAGES.includes(locale) ? locale : LANGUAGE_DE;
}
